import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'components'
import WeChatButton from '../WeChatButton'
import styles from './index.module.less'
import classnames from 'classnames'

export default function Index({ className, ...props }: any) {
  const history = useHistory()
  return (
    <div className={classnames(styles.box, className)}>
      <Button className={styles.loginButton} htmlType="submit" {...props}>
        登 录
      </Button>
      <div className={styles.or}>或者</div>
      <WeChatButton onClick={() => history.push('/mobile/work-wechat')} />
    </div>
  )
}
